"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeWorkPlane = exports.WorkplaneShape = exports.WorkPlaneUnits = void 0;
const ValueObjects_1 = require("../ValueObjects");
const TransformNode_1 = require("./TransformNode");
var WorkPlaneUnits;
(function (WorkPlaneUnits) {
    WorkPlaneUnits[WorkPlaneUnits["INCHES"] = 0] = "INCHES";
    WorkPlaneUnits[WorkPlaneUnits["METERS"] = 1] = "METERS";
    WorkPlaneUnits[WorkPlaneUnits["FEET"] = 2] = "FEET";
})(WorkPlaneUnits = exports.WorkPlaneUnits || (exports.WorkPlaneUnits = {}));
var WorkplaneShape;
(function (WorkplaneShape) {
    WorkplaneShape[WorkplaneShape["RECTANGE"] = 0] = "RECTANGE";
    WorkplaneShape[WorkplaneShape["CIRCLE"] = 1] = "CIRCLE";
    WorkplaneShape[WorkplaneShape["UNKNOWN"] = 2] = "UNKNOWN";
})(WorkplaneShape = exports.WorkplaneShape || (exports.WorkplaneShape = {}));
function makeWorkPlane() {
    return new WorkPlaneImp();
}
exports.makeWorkPlane = makeWorkPlane;
class WorkPlaneImp {
    constructor() {
        this._workPlaneHalfSize = ValueObjects_1.Vector2.One();
        this.showWorkPlane = true;
        this.transform = TransformNode_1.makeTransformNode();
        this.id = "workplane";
        this._units = WorkPlaneUnits.METERS;
        this._workplaneShape = WorkplaneShape.UNKNOWN;
        this.setWorkplaneSize = (size) => {
            this._workPlaneSize = size;
            this._workPlaneHalfSize = new ValueObjects_1.Vector2(0.5 * size.x, 0.5 * size.y);
            this._workplaneShape = WorkplaneShape.RECTANGE;
        };
        this.setWorkplaneRadius = (radius) => {
            this._workPlaneRadius = radius;
            this._workplaneShape = WorkplaneShape.CIRCLE;
        };
        this.pickOnWorkplane = (ray, unconstrained = false) => {
            const worldPos = this.transform.worldPosition;
            const worldUp = this.transform.localDirectionToWorld(ValueObjects_1.Vector3.Up());
            const pickPlane = ValueObjects_1.ParametricPlane.FromPointNormal(worldPos, worldUp);
            const worldPick = pickPlane.intersectLine(ray);
            if (worldPick === undefined) {
                return undefined;
            }
            const localPick = this.transform.worldPointToLocal(worldPick);
            const workPlanePick = new ValueObjects_1.Vector2(localPick.x, localPick.z);
            if (unconstrained) {
                return workPlanePick;
            }
            if (this._workplaneShape === WorkplaneShape.CIRCLE) {
                return this.constrainToRadius(workPlanePick);
            }
            else if (this._workplaneShape === WorkplaneShape.RECTANGE) {
                return this.constrainToSize(workPlanePick);
            }
            else {
                return workPlanePick;
            }
        };
    }
    get workPlaneRadius() {
        return this._workPlaneRadius;
    }
    get workPlaneSize() {
        return this._workPlaneSize;
    }
    get units() {
        return this._units;
    }
    set units(val) {
        if (val === this._units)
            return;
        this._units = val;
        const scale = 1 / this.conversionFactor;
        this.transform.localScale = new ValueObjects_1.Vector3(scale, scale, scale);
    }
    get workplaneShape() {
        return this._workplaneShape;
    }
    get conversionFactor() {
        switch (this.units) {
            case WorkPlaneUnits.FEET:
                return 3.28084;
            case WorkPlaneUnits.INCHES:
                return 39.3701;
            case WorkPlaneUnits.METERS:
                return 1;
            default:
                console.warn("[WorkPlane] Unknown units " + this.units);
                return 1;
        }
    }
    constrainToRadius(workPlanePick) {
        if (!this.workPlaneRadius)
            return workPlanePick;
        const pickRadius = workPlanePick.magnitued;
        if (pickRadius <= this.workPlaneRadius) {
            return workPlanePick;
        }
        else {
            return undefined;
        }
    }
    constrainToSize(workPlanePick) {
        if (!this._workPlaneHalfSize)
            return workPlanePick;
        const x = workPlanePick.x;
        const maxX = this._workPlaneHalfSize.x;
        const minX = -this._workPlaneHalfSize.x;
        const y = workPlanePick.y;
        const maxY = this._workPlaneHalfSize.y;
        const minY = -this._workPlaneHalfSize.y;
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
            return workPlanePick;
        }
        else {
            return undefined;
        }
    }
}
